import { useContext, useState } from 'react';
import { SPLIT_DOC_PARAMETERS } from '../../core/constants';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import useCommonStyles from '../../commonStyles';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import SplitCard from './SplitCard';
import PieChartVisualizerIcon from '../../Components/PieChartVisualizer';
//mui imports====
import { Grid, Paper, Button } from '@mui/material';
import { toast } from 'react-toastify';
import { PLATFORMS, GLOBAL_COUNTRY } from '../../core/constants';
import DropDownSingle from '../../Components/DropDownSingle';
const { GLOBAL_PLATFORM } = PLATFORMS;
//===============

const { SPLIT_CONFIGS, SPLITS, SCRIPTS, KEY, SPLIT } = SPLIT_DOC_PARAMETERS;

const SplitConfig = ({ splitDoc, updateSplitDoc }) => {
	const { updateModalContent } = useContext(Modalv2Context);

	const splitConfigsObj = splitDoc && splitDoc[SPLIT_CONFIGS];
	const selectedPlatform = GLOBAL_PLATFORM;
	const selectedCountry = GLOBAL_COUNTRY;
	const selectedSplitConfig =
		splitConfigsObj &&
		splitConfigsObj[selectedPlatform] &&
		splitConfigsObj[selectedPlatform][selectedCountry];

	let splitVisualizerData = selectedSplitConfig?.[SPLITS] || [];
	splitVisualizerData = splitVisualizerData.map((splitData) => {
		return { id: splitData[KEY], value: splitData[SPLIT], label: splitData[KEY] };
	});
	const commonStyleClasses = useCommonStyles();

	const getScriptNamesAvailable = () => {
		const allScriptNames = Object.keys(splitDoc?.[SCRIPTS] || []);
		let scriptNamesAlreadyAdded = selectedSplitConfig?.[SPLITS] || [];
		scriptNamesAlreadyAdded = scriptNamesAlreadyAdded.map((splitData) => splitData[KEY]);
		const scriptNamesAvailable = allScriptNames.reduce((scriptNamesArr, curScriptName) => {
			const isScriptAlreadyAdded = scriptNamesAlreadyAdded.includes(curScriptName);

			if (!isScriptAlreadyAdded) {
				scriptNamesArr.push(curScriptName);
			}
			return scriptNamesArr;
		}, []);
		return scriptNamesAvailable;
	};

	const scriptNames = getScriptNamesAvailable();

	const updateSplitObj = (index, newSplitObj) => {
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedSplitConfigsObj = clonedSplitDoc && clonedSplitDoc[SPLIT_CONFIGS];
		const clonedSelectedSplitConfig =
			clonedSplitConfigsObj &&
			clonedSplitConfigsObj[selectedPlatform] &&
			clonedSplitConfigsObj[selectedPlatform][selectedCountry];
		const splitsArr = clonedSelectedSplitConfig[SPLITS];

		splitsArr[index] = newSplitObj;
		updateSplitDoc(clonedSplitDoc);
	};

	const addSplit = (scriptName) => {
		if (!scriptName) {
			toast.error('Need a valid script name', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			return;
		}
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedSplitConfigsObj = clonedSplitDoc && clonedSplitDoc[SPLIT_CONFIGS];
		const clonedSelectedSplitConfig =
			clonedSplitConfigsObj &&
			clonedSplitConfigsObj[selectedPlatform] &&
			clonedSplitConfigsObj[selectedPlatform][selectedCountry];
		const splitsArr = clonedSelectedSplitConfig[SPLITS];

		const initialSplitData = { [KEY]: scriptName, [SPLIT]: 0 };
		splitsArr.push(initialSplitData);
		updateSplitDoc(clonedSplitDoc);
		updateModalContent(null);
	};

	const deleteSplitObj = (index) => {
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedSplitConfigsObj = clonedSplitDoc && clonedSplitDoc[SPLIT_CONFIGS];
		const clonedSelectedSplitConfig =
			clonedSplitConfigsObj &&
			clonedSplitConfigsObj[selectedPlatform] &&
			clonedSplitConfigsObj[selectedPlatform][selectedCountry];
		let splitsArr = clonedSelectedSplitConfig[SPLITS];
		clonedSelectedSplitConfig[SPLITS] = splitsArr.filter((val, idx) => idx !== index);
		updateSplitDoc(clonedSplitDoc);
	};

	return (
		<Paper sx={{ padding: '3rem', margin: '3rem 6rem 3rem 3rem' }}>
			{selectedSplitConfig && selectedSplitConfig[SPLITS] && (
				<>
					<Grid container spacing={2}>
						<Grid item xs={12} marginBottom="1rem" marginRight="1.5rem">
							<PieChartVisualizerIcon
								data={splitVisualizerData}
								sumRes={100}
								updateModalContent={updateModalContent}
							/>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{
							border: '1px solid rgba(0, 0, 0, 0.38)',
							padding: '1rem',
							margin: '.4rem 10rem .4rem 0',
							borderRadius: '4px',
							width: '98.5%'
						}}
					>
						{selectedSplitConfig[SPLITS].map((splitData, index) => {
							return (
								<SplitCard
									key={index}
									splitData={splitData}
									index={index}
									updateSplitObj={updateSplitObj}
									deleteSplitObj={deleteSplitObj}
								/>
							);
						})}

						{scriptNames.length > 0 && (
							<Grid item xs={12} style={{ textAlign: 'center', marginTop: '1rem' }}>
								<AddCircleIcon
									color="primary"
									fontSize="medium"
									className={commonStyleClasses.icon}
									onClick={() =>
										updateModalContent(
											<AddSplitModal addSplit={addSplit} scriptNames={scriptNames} />
										)
									}
								/>
							</Grid>
						)}
					</Grid>
				</>
			)}
		</Paper>
	);
};

const AddSplitModal = ({ addSplit, scriptNames }) => {
	const commonStyleClasses = useCommonStyles();
	const [scriptKey, setScriptKey] = useState('');

	return (
		<Grid container spacing={2} className={commonStyleClasses.modalContentStyle}>
			<Grid item xs={12}>
				<DropDownSingle
					isObjectEditor={false}
					directValue={scriptKey}
					updateDirectValue={setScriptKey}
					list={scriptNames}
					label="Script Name"
				/>
			</Grid>
			<Grid item xs={12}>
				<Button
					variant="contained"
					onClick={() => {
						addSplit(scriptKey);
					}}
				>
					Add Script Split
				</Button>
			</Grid>
		</Grid>
	);
};

export default SplitConfig;
